<mat-card class="form-card" *ngIf="!loading">
  <form [formGroup]="profileForm" (ngSubmit)="onSave()">
    <div class="form-container">
      <!-- Personal Information Fields -->
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="lastName" required>
        <mat-error *ngIf="profileForm.get('lastName')?.hasError('required')">
          Last Name is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>First Name</mat-label>
        <input matInput formControlName="firstName" required>
        <mat-error *ngIf="profileForm.get('firstName')?.hasError('required')">
          First Name is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Gender</mat-label>
        <mat-select formControlName="gender">
          <mat-option *ngFor="let gender of genders" [value]="gender">{{ gender }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Marital Status</mat-label>
        <mat-select formControlName="maritalStatus">
          <mat-option *ngFor="let status of maritalStatuses" [value]="status">{{ status }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field date-field">
        <mat-label>Date of Birth</mat-label>
        <input matInput AutoSlashDateFormatDirective formControlName="dateOfBirth" [matDatepicker]="picker" required>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="profileForm.get('dateOfBirth')?.hasError('required')">
          Date of Birth is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Phone Number</mat-label>
        <input matInput formControlName="phoneNumber" required>
        <mat-error *ngIf="profileForm.get('phoneNumber')?.hasError('required')">
          Phone Number is required
        </mat-error>
        <mat-error *ngIf="!(profileForm.get('phoneNumber')?.hasError('required')) && profileForm.get('phoneNumber')?.hasError('invalidPhoneNumber')">
          Invalid Phone Number
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" required>
        <mat-error *ngIf="profileForm.get('email')?.hasError('required')">
          Email is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Patient Status</mat-label>
        <input matInput formControlName="patientStatus">
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Text Message Consent</mat-label>
        <mat-select formControlName="textMessageConsent">
          <mat-option value="Yes">Yes</mat-option>
          <mat-option value="No">No</mat-option>
          <mat-option value="Unknown">Unknown</mat-option>
        </mat-select>
      </mat-form-field>
      
      <div class="consent-message">
        <small>
          By providing your phone number you agree to receive informational text messages from our healthcare practice. 
          Consent is not a condition of treatment. Message frequency will vary. 
          Msg & data rates may apply. Reply HELP for help or STOP to cancel.
        </small>
      </div>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Is New Patient</mat-label>
        <input matInput formControlName="isNewPatient">
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field ssn-field">
        <mat-label>SSN</mat-label>
        <input matInput  autoDashSSNFormat [placeholder]="'xxx-xx-xxxx'"  [type]="hide ? 'password' : 'text'" formControlName="ssn">
        <button mat-icon-button matSuffix (click)="toggleHide()">
          <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Language</mat-label>
        <input matInput formControlName="language">
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Preferred Contact Method</mat-label>
        <mat-select formControlName="preferredContactMethod">
          <mat-option *ngFor="let method of contactMethods" [value]="method">{{ method }}</mat-option>
        </mat-select>
      </mat-form-field>

      <div class="address-section">
        <div class="address-section-header">Address Information</div>

        <app-address-auto-complete (addressSelected)="onAddressSelected($event)"></app-address-auto-complete>

        <mat-form-field appearance="outline" class="form-field street-address-field">
          <mat-label>Street Address</mat-label>
          <input matInput formControlName="address" required>
          <mat-error *ngIf="profileForm.get('address')?.hasError('required')">
            Address is required
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>City</mat-label>
          <input matInput formControlName="city" required>
          <mat-error *ngIf="profileForm.get('city')?.hasError('required')">
            City is required
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>State</mat-label>
          <mat-select formControlName="state">
            <mat-option *ngFor="let state of states" [value]="state">{{ state }}</mat-option>
          </mat-select>
          <mat-error *ngIf="profileForm.get('state')?.hasError('required')">
            State is required
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>ZIP Code</mat-label>
          <input matInput formControlName="zipCode" required>
          <mat-error *ngIf="profileForm.get('zipCode')?.hasError('required')">
            ZIP Code is required
          </mat-error>
          <mat-error *ngIf="!(profileForm.get('zipCode')?.hasError('required')) && profileForm.get('zipCode')?.hasError('invalidZipCode')">
            Invalid ZIP Code
          </mat-error>
        </mat-form-field>
      </div>

      <div class="button-container">
        <button mat-raised-button color="primary" type="submit" [disabled]="!isFormEdited">Save</button>
        <button mat-raised-button color="warn" type="button" (click)="onCancel()">Cancel</button>
      </div>
    </div>
  </form>
</mat-card>

<div class="loading-container" *ngIf="loading">
  <mat-spinner [diameter]="50" [color]="'primary'"></mat-spinner>
</div>
